// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3760a91","455":"2c505cfc","488":"d2f7ebe2","977":"de393a27"}[chunkId] + ".chunk.js";
};